function convertSchemaToColumns(
  schema,
  formatMessage,
  accessorFunctions,
  accessorFunctionsAdditional = {},
  stickyColumn = false,
) {
  return schema.map((schemaItem, index) => ({
    ...(stickyColumn &&
      index === 0 && {
        muiTableHeadCellProps: {
          sx: {
            position: 'sticky',
            left: 0,
            zIndex: 2,
            backgroundColor: '#fff',
          },
        },
        muiTableBodyCellProps: {
          sx: {
            position: 'sticky',
            left: 0,
            zIndex: 1,
            backgroundColor: '#fff',
          },
        },
      }),
    accessorKey: schemaItem.accessorKey,
    header: schemaItem.header
      ? formatMessage({
          id: schemaItem.header.localeId,
          defaultMessage: schemaItem.header.defaultMessage,
        })
      : null,
    ...(schemaItem?.size !== undefined && {
      size: schemaItem.size,
    }),
    ...(schemaItem?.enableColumnActions !== undefined && {
      enableColumnActions: schemaItem.enableColumnActions,
    }),
    ...(schemaItem?.enableHiding !== undefined && {
      enableHiding: schemaItem.enableHiding,
    }),
    ...(schemaItem?.enableSorting !== undefined && {
      enableSorting: schemaItem.enableSorting,
    }),
    ...(schemaItem?.accessorFn && {
      Cell: props => {
        const {
          row: { original },
        } = props;
        if (typeof accessorFunctions[schemaItem.accessorFn] === 'function') {
          return accessorFunctions[schemaItem.accessorFn](
            original,
            props,
            accessorFunctionsAdditional,
          );
        }
        throw new Error(
          `Function ${schemaItem.accessorFn} does not exist column definition`,
        );
      },
    }),
  }));
}

export default convertSchemaToColumns;
